/**
 * WCAG 1.3.1 helper for CMS-authored HTML.
 *
 * The rich-text editor historically produced `<strong>` / `<em>` / `<b>` / `<i>`
 * for visual bold/italic. Those tags carry semantic importance, so we normalize
 * them to styled `<span>` elements for purely visual emphasis. Content that
 * genuinely needs strong emphasis should be authored intentionally (e.g. through
 * a semantic-emphasis control or raw HTML), not via the Bold/Italic toolbar.
 */
export function sanitizeAccessibleHtml(html: string): string {
  return html
    .replace(/<(strong|b)\b[^>]*>/gi, '<span style="font-weight:700">')
    .replace(/<\/(strong|b)>/gi, "</span>")
    .replace(/<(em|i)\b[^>]*>/gi, '<span style="font-style:italic">')
    .replace(/<\/(em|i)>/gi, "</span>")
    // WCAG 1.3.1: strikethrough almost always marks an original / pre-sale price.
    // Read alone the number has no context, so prefix it with an sr-only label —
    // screen readers announce "Original price: $100" instead of a bare "$100".
    .replace(/<(s|del)\b[^>]*>/gi, '<span class="sr-only">Original price: </span><$1>');
}
